import { render } from "./AddFollowUp.vue?vue&type=template&id=03871c17&scoped=true"
import script from "./AddFollowUp.vue?vue&type=script&lang=js"
export * from "./AddFollowUp.vue?vue&type=script&lang=js"

import "./AddFollowUp.vue?vue&type=style&index=0&id=03871c17&scoped=true&lang=css"
import "./AddFollowUp.vue?vue&type=style&index=1&id=03871c17&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03871c17"]])

export default __exports__